import $ from 'jquery';

const popup = $('.AddedToCartPopup');

function playHurraSound() {
    const audio = new Audio(
        '/wp-content/themes/starter/dist/images/sounds/hurra-dodano-do-koszyka.wav',
    );
    audio.play();
}

import JSConfetti from 'js-confetti';
const jsConfetti = new JSConfetti();

const showPopup = (content) => {
    popup.find('.AddedToCartPopup__content').html(content);
    popup.addClass('open');
    playHurraSound();
    jsConfetti.addConfetti({
        emojis: ['🎊', '🤗', '🎉','🎈'],
        emojiSize: 60,
        confettiNumber: 90,
    });
};
const hidePopup = () => {
    popup.find('.AddedToCartPopup__content').html();
    popup.removeClass('open');
};

const fetchLatestProductData = () => {
    $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'kreacja_ajax_latest_atc',
        },
        success: (response) => {
            if (response.success) {
                showPopup(response.data.content);
            }
        },
    });
};

$(document.body).on('added_to_cart', fetchLatestProductData);

$('.AddedToCartPopup__continue, .AddedToCartPopup__closeButton ').on('click', hidePopup);
